<p-dialog
  [(visible)]="visible"
  [style]="{ width: '500px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="close()"
  [header]="modelRecived ? 'Editar Motivo' : 'Nuevo Motivo'"
>
  <form [formGroup]="form" (ngSubmit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P112F0001">
    <div class="form-row mt-3">
      <div class="form-field">
        <input pInputText type="text" formControlName="motivo" class="form-control" [placeholder]="'Ingrese código'" [appPermissionControl]="'P112K0001'" appPermissionControl="P112K0005">
        <label>Código</label>
        <small class="p-error" *ngIf="formValue('motivo')?.errors?.required && form.get('motivo')?.touched"> Campo requerido </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field flex-grow-1">
        <p-dropdown
          [options]="listTipos"
          formControlName="tipo"
          optionLabel="sOpcion"
          optionValue="sValor"
          [placeholder]="'Seleccione'"
          class="w-100"
          appendTo="body"
          appPermissionControl="P112K0002"
        ></p-dropdown>
        <label>Tipo Motivo</label>
        <small class="p-error" *ngIf="formValue('tipo')?.errors?.required && form.get('tipo')?.touched"> Campo requerido </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <input pInputText type="text" formControlName="descripcion" class="form-control" [placeholder]="'Ingrese descripción'" appPermissionControl="P112K0003" />
        <label>Descripción</label>
        <small class="p-error" *ngIf="formValue('descripcion')?.errors?.required && form.get('descripcion')?.touched"> Campo requerido </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field flex-grow-1">
        <p-dropdown
          [options]="listTipo_Motivo"
          formControlName="tipo_motivo"
          optionLabel="sOpcion"
          optionValue="sValor"
          [placeholder]="'Seleccione'"
          class="w-100"
          appendTo="body"
          appPermissionControl="P112K0004"
        ></p-dropdown>
        <label>Clasificador</label>
        <small class="p-error" *ngIf="formValue('tipo_motivo')?.errors?.required && form.get('tipo_motivo')?.touched"> Campo requerido </small>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="button-section">
      <button mat-flat-button class="btn-success" (click)="modelRecived ? update(form.value) : create(form.value)" [disabled]="!form.valid || loading" appPermissionControl="P112B0001">
        <mat-icon>save</mat-icon>
        {{ modelRecived ? 'Actualizar' : 'Guardar' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<style>
  :host ::ng-deep .p-dropdown {
    width: 100%;
    height: 32px;
  }

  :host ::ng-deep .p-dropdown-panel {
    width: 100%;
  }

  :host ::ng-deep .p-dropdown-filter {
    width: 100%;
    padding: 0.5rem;
  }

  :host ::ng-deep .p-dropdown .p-dropdown-label {
    font-size: 12px !important;
  }

  :host ::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
    font-size: 12px !important;
  }
</style>
